import type { IProgressLine } from './ProgressLine'

import { styled } from '@linaria/react'

export const ProgressLineBaseSC = styled.div<IProgressLine>`
  display: flex;
  width: 100%;
  max-width: 80px;
  height: 100%;
  background: ${({ backgroundOverlay }) => `var(${backgroundOverlay})`};
  position: absolute;
  top: 0;
  left: ${({ position }) => `clamp(1px, ${position}px, 100% - 80px)`};
  pointer-events: none;
`

export const ProgressLineSimpleColorSC = styled(
  ProgressLineBaseSC
)<IProgressLine>`
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: ${({ borderColor }) => `var(${borderColor})`};
`

export const ProgressLineGradientColorSC = styled(
  ProgressLineBaseSC
)<IProgressLine>`
  border-image: ${({ borderColor }) => `var(${borderColor}) 1`};
  border-width: 0;
  border-style: solid;
  border-image-width: 0 1px 0 0;
`
